import * as React from 'react'
import { useCallback } from 'react'
import IconButton from '@mui/material/IconButton'
import Close from '@mui/icons-material/Close'

import { useClosingReqContext } from '../../context'
import { setActiveRequirementActionCreator } from '../../state'

export function CloseButton() {
  const [, dispatch] = useClosingReqContext()

  const onClick = useCallback(
    () => dispatch(setActiveRequirementActionCreator(undefined)),
    [dispatch],
  )

  return (
    <IconButton onClick={onClick} data-test-id="closingRequirementCloseBtn">
      <Close />
    </IconButton>
  )
}
